import React, { useReducer, useEffect, useCallback } from 'react';
import { initialState, reducer, StoreContext } from './store';


const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StoreContext.Provider value={{ state, dispatch }}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreProvider;
